import { useContext } from "react";

import { FilteredArticlesContext } from "@brexhq/next/src/contexts/FilteredArticlesContext";
import {
  ArticleData,
  RepeatableContentKey,
} from "@brexhq/next/src/utils/repeatableContent/repeatableContentUtils";

/**
 * Provides article data for display given a repeatable content key
 */
export const useFilteredArticles = (
  repeatableContentKey: RepeatableContentKey,
): Array<ArticleData> => {
  const { repeatableArticles, repeatableBundles } = useContext(
    FilteredArticlesContext,
  );

  if (repeatableBundles[repeatableContentKey]) {
    return repeatableBundles[repeatableContentKey].map(
      (el) => repeatableArticles[el],
    );
  }
  return [];
};
